import { message } from 'antd';

const isAuthErrorCode = (code?: number) => code === -1 || code === 401;

/** 全局 errorHandler 已展示过的 BizError 标记 */
export const BIZ_ERROR_NOTIFIED = '__bizErrorNotified';

const recentKeys = new Map<string, number>();
const DEDUPE_MS = 2000;

const buildKey = (code: number | string, content: string) => `${code}:${content}`;

/**
 * 展示接口业务错误（同内容 2 秒内去重，避免重复弹窗）
 */
export function showApiErrorMessage(code: number | string, content: string) {
  const text = content || '请求失败';
  const key = buildKey(code, text);
  const now = Date.now();
  const last = recentKeys.get(key);
  if (last != null && now - last < DEDUPE_MS) {
    return false;
  }
  recentKeys.set(key, now);
  message.error(text);
  return true;
}

/** 是否为已在全局拦截器处理过的业务错误 */
export function isBizErrorHandled(error: unknown): boolean {
  const e = error as { name?: string; info?: { code?: number }; [BIZ_ERROR_NOTIFIED]?: boolean };
  if (e?.name === 'BizError' || Boolean(e?.[BIZ_ERROR_NOTIFIED])) {
    return true;
  }
  return isAuthErrorCode(e?.info?.code);
}

/**
 * 页面 catch 中调用：全局已提示过的 BizError 不再重复 message.error
 */
export function notifyRequestCatchError(error: unknown, fallback = '请求失败，请稍后重试') {
  if (isBizErrorHandled(error)) {
    return;
  }
  const e = error as { message?: string };
  message.error(e?.message || fallback);
}
